<template>
  <div class="page-template add-page" v-loading="loading">
    <div class="page-title">{{ title }}</div>
    <div class="btn-box">
      <el-button @click="beBack" type="primary" plain>返回</el-button>
      <el-button @click="refresh" type="primary" plain>刷新</el-button>
      <el-button @click="submitAuth" type="primary" plain>保存</el-button>
      <el-button @click="audit(3)" type="primary" plain :disabled="formModel.reviewerStatus === null">审核
      </el-button>
      <el-button @click="franchiseStoreChange" type="primary" plain>对账查询</el-button>
    </div>
    <list-operation-form
      ref="listOperationForm"
      :formOptions="listFormOptions"
      @valueChange="listFormValueChange">
    </list-operation-form>
    <list-operation ref="listOperation" :tableOptions="listColumns"
                    @selectRowChange="selectShowChange"></list-operation>
  </div>
</template>
<script>

  //添加要货单组件
  import listOperation from '@/components/template/listOperation';
  //要货单搜索组件
  import listOperationForm from '@/components/template/listOperationForm';
  import api from '@/config/api';

  export default {
    components: {
      listOperation,
      listOperationForm
    },
    data() {
      return {
        isExistNullPrince: 0,
        formModel: {reviewerStatus: null},
        loading: false,
        title: '',
        listShow: false,
        dialogShow: false,
        dataRows: [],
        //头部条件
        listFormOptions: {
          disabled: false,
          statusOption: {
            prop: 'reviewerStatus',
            statusImg: {
              10: '/static/checked.png',
              20: '/static/un-check.png'
            },
          },
          labelWidth: '130px',
          columns: [
            {
              prop: 'id',
              hidden: true
            },
            {
              label: '业务单号',
              type: 'input',
              prop: 'orderNo',
              span: 8,
              disabled: true,
            }, {
              label: "加盟店",
              type: "storeInputDialog",
              prop: "franchiseStoreId",
              // data: [],
              span: 8,
              params: {storeClass: 2},
              // change: this.franchiseStoreChange,
              rule: [
                {required: true, message: "请选择加盟店", trigger: "change"},
              ],
            },
            {
              label: '付款方式',
              type: 'select',
              prop: 'payType',
              data: this.$utils.getCacheStatus("stFranchiseSettlementOrder.payType"),
              span: 8,
            },
            {
              label: '付款金额',
              prop: 'billAmount',
              type: "input",
              span: 8,
              disabled: true
            },
            {
              label: '备注',
              prop: 'remarks',
              type: "input",
              span: 8,
            }
          ]
        },
        // 添加表格字段
        listColumns: {
          height: this.height,
          showSelect: true,
          disabled: false,
          summaryColumns: ['payAmount', 'amountPaid', 'discountedAmount', 'outstandAmount', 'actualPayAmount', 'discountMoney'],
          columns: [
            {label: '序号', type: 'index', width: 80, prop: 'idx'},
            {
              label: '单据号',
              prop: 'billOrderNo',
              width: '180',
              align: "center",
              callback: this.goOrderDetail,
            },
            {
              label: "单据类型",
              prop: "type",
              width: '120',
              align: "center",
              enumData: this.$utils.getCacheStatus('stFranchiseSettlementMap.type')
            },
            {
              label: "单据日期",
              prop: "billDttm",
              width: '90',
              align: "center"
            },
            {
              label: '应收金额',
              width: '90',
              prop: 'payAmount',
              align: "center",
            },
            {
              label: '已收金额',
              width: '125',
              prop: 'amountPaid',
              align: "center"
            },
            {
              label: '已优惠金额',
              width: '90',
              prop: 'discountedAmount',
              align: "center"
            },
            {
              label: '未收金额',
              width: '90',
              prop: 'outstandAmount',
              align: "center"
            },
            {
              label: '实收金额',
              width: '90',
              prop: 'actualPayAmount',
              align: "center",
              type: 'inputNumber',
              min: -Infinity,
              precision: 2,
              change: this.payAmountChange
            },
            {
              label: '优惠金额',
              width: '90',
              prop: 'discountMoney',
              align: "center",
              type: 'inputNumber',
              precision: 2
            },
            {
              label: '备注',
              prop: 'remarks',
              width: '90',
              align: "center"
            },
          ]
        },
        checkIndex: '',
        detailColumns: {
          statusOption: {
            prop: 'reviewerStatus',
            statusImg: {
              10: '/static/checked.png',
              20: '/static/un-check.png'
            },
            right: '200px',
            top: '30px',
          },
          span: 8,
          labelWidth: "130",
          columns: [
            {
              label: '业务单号',
              prop: 'orderNo',
            }, {
              label: '加盟店',
              prop: 'franchiseStoreName',
            }, {
              label: '单据金额',
              prop: 'billAmount',
            }, {
              label: '备注',
              prop: 'remarks',
            }],
          tablesProp: {
            stFranchiseStoreBillMapList: {
              height: this.detailHeight,
              tableName: "stFranchiseStoreBillMapList",
              summaryColumns: ['payAmount'],
              columns: [
                {
                  label: '单据号',
                  prop: 'allocationOrderNo',
                  width: '180',
                  align: "center"
                },
                {
                  label: '业务类型',
                  width: '90',
                  prop: 'type',
                  align: "center",
                  enumData: this.$utils.getCacheStatus('stFranchiseStoreBillMap.type'),
                },
                {
                  label: '单据日期',
                  width: '125',
                  prop: 'allocationDttm',
                  align: "center"
                },
                {
                  label: '应收金额',
                  width: '90',
                  prop: 'payAmount',
                  align: "center"
                },
                {
                  label: '备注',
                  prop: 'remarks',
                  width: '90',
                  align: "center"
                },
              ],
            }
          },

          // 打印的列表
          printTablesProp: {
            stFranchiseStoreBillMapList: {
              tableName: 'stFranchiseStoreBillMapList',
              showSummary: true,
              summaryColumns: ['payAmount'],
              columns: [
                {
                  label: '单据号',
                  prop: 'allocationOrderNo',
                  width: '180',
                  align: "center"
                },
                {
                  label: '业务类型',
                  width: '90',
                  prop: 'type',
                  align: "center",
                  enumData: this.$utils.getCacheStatus('stFranchiseStoreBillMap.type'),
                },
                {
                  label: '单据日期',
                  width: '125',
                  prop: 'allocationDttm',
                  align: "center"
                },
                {
                  label: '应收金额',
                  width: '90',
                  prop: 'payAmount',
                  align: "center"
                },
                {
                  label: '备注',
                  prop: 'remarks',
                  width: '90',
                  align: "center"
                },
              ],
            },
          },
          url: api.settle.billFranchise
        }
      }
    },
    beforeCreate() {
      this.height = document.documentElement.clientHeight - 180 - 200
    },
    created() {
      this.getStore();
      this.title = (this.$route.query.id ? '编辑' : '新增') + document.title;
      if (this.$route.query.id) {
        this.getDetail();
      }
    },
    methods: {
      listFormValueChange(value, column) {
        if (column.prop == "franchiseStoreId") {
          this.$refs.listOperationForm.formModel.franchiseStoreId = value.id;
          this.$refs["listOperation"].clearTableData();
        }
      },
      payAmountChange() {
        if (this.dataRows.length > 0) {
          let billAmount = 0;
          this.dataRows.map(item => {
            billAmount = billAmount + parseFloat(item.actualPayAmount);
          });
          this.$refs.listOperationForm.formModel.billAmount = billAmount.toFixed(2);
        }
      },
      goOrderDetail(row) {
        this.$utils.setDataByKey(this.$utils.storeKeys.FORMINFO, this.detailColumns);
        const {href} = this.$router.resolve({
          name: "BillFranchiseDetail",
          query: {id: row.billId},
        });
        window.open(href, "_blank");
      },
      //编辑
      getDetail() {
        this.loading = true;
        this.$axios
          .fetchGet(api.settle.franchiseSettlement + '?id=' + this.$route.query.id, {}).then(data => {
          this.formModel = data.data;
          if (this.formModel.reviewerStatus === 10) {
            this.listFormOptions.disabled = true;
            this.listColumns.disabled = true;
          }
          this.loading = false;
          if (data.code === 200) {
            this.listFormOptions.columns.filter(
              (item) => item.prop === "franchiseStoreId"
            )[0].disabled = true;
            //为头部表单赋值
            this.$refs.listOperationForm.formModel = data.data;
            //为表格赋值
            this.$refs['listOperation'].addMoreRow(data.data.stFranchiseStoreSettlementMapList, 0);
            this.$nextTick(() => {
              this.$refs['listOperation'].selectAll();
            });
          } else {
            this.$message({message: data.msg, type: 'error'});
          }
        }).catch(err => {
          this.$message({message: '请求失败！', type: 'error'});
          this.loading = false;
        });
      },

      //提交数据
      submitAuth(e) {
        //获取选择的list数据
        let tableList = this.$refs['listOperation'].selectRows;
        //将合计的值重新赋值给后端接收的参数
        let totalParam = this.$refs['listOperation'].getSumData();
        //将表头的值重新赋值给后端接收的参数
        let headParam = this.$refs.listOperationForm.getFormModel();
        headParam.reviewerStatus = 20;
        console.log(headParam);
        let searchParam = {
          ...{stFranchiseStoreSettlementMapList: tableList}, ...totalParam, ...headParam
        };
        if (tableList.length === 0) {
          this.$message({message: "请勾选数据！", type: "warning"});
        } else {
          if (tableList[tableList.length - 1].id !== undefined) {
            this.saveData(headParam, e, searchParam);
          } else {
            this.$message({message: "请勿勾选合计数据！", type: "warning"});
          }
        }
      },

      saveData(headParam, e, searchParam) {
        if (headParam.id) {
          if (e === 3) {
            this.$confirm("是否确认审核?", "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }
            ).then(() => {
              this.handleRequest(this.$axios
                .fetchPost(api.settle.franchiseSettlement + '/settlement/audit', searchParam), e);
            }).catch(() => this.$message({message: "审核取消！", type: "info"}));
          } else {
            this.$confirm("是否确认保存?", "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }
            ).then(() => {
              this.handleRequest(this.$axios
                .fetchPut(api.settle.franchiseSettlement, searchParam), e);
            }).catch(() => this.$message({message: "保存取消！", type: "info"}));
          }
        } else {
          this.$confirm("是否确认保存?", "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            }
          ).then(() => {
            this.handleRequest(this.$axios
              .fetchPost(api.settle.franchiseSettlement, searchParam), e);
          }).catch(() => this.$message({message: "保存取消！", type: "info"}));
        }
      },
      //处理添加和编辑的请求
      handleRequest(parm, e) {
        parm.then(data => {
          this.loading = false;
          if (data.code === 200) {
            if (e === 3) {
              this.$notify({
                type: "success",
                title: '审核操作',
                message: '成功',
                showClose: false,
              });
              // this.$message({message: "审核成功！", type: "success"});
              this.$router.push({path: '/settlement/franchise'});
            } else {
              this.$notify({
                type: "success",
                title: '保存操作',
                message: '成功',
                showClose: false,
              });
              // this.$message({message: "保存成功！", type: "success"});
              this.dialogShow = false;
              this.$refs.listOperationForm.formModel = data.data;
              this.formModel.reviewerStatus = data.data.reviewerStatus;
            }
          } else {
            if (e === 3) {
              this.$notify({
                type: "error",
                title: '审核操作',
                message: '失败',
                showClose: false,
              });
              // this.$message({message: "审核失败！", type: "error"});
            } else {
              this.$notify({
                type: "error",
                title: '保存操作',
                message: '失败',
                showClose: false,
              });
              // this.$message({message: "保存失败！", type: "error"});
            }
          }
        })
          .catch(err => {
            this.$message({message: '请求失败！', type: 'error'});
            this.loading = false;
          });
      },

      //返回按钮事件
      beBack() {
        this.$router.go(-1);
      },
      refresh(e) {
        this.$router.go(0);
      },
      // 审核
      audit(e) {
        this.submitAuth(e);
      },
      franchiseStoreChange() {
        let form = this.$refs.listOperationForm.getFormModel();
        if (!form.franchiseStoreId) {
          this.$message.warning("请选择门店");
          return;
        }
        if (form.franchiseStoreId) {
          this.$refs["listOperation"].clearTableData();
          this.$axios.fetchPost(api.settle.franchiseSettlement + '/franchise/bill/order',
            {franchiseStoreId: form.franchiseStoreId}).then((data) => {
            if (data.code === 200) {
              if (data.data.length > 0) {
                //为表格赋值
                data.data.map((item, index) => {
                  item.id = index + 1;
                });
                this.$refs["listOperation"].addMoreRow(data.data, 0);
              } else {
                this.$message({message: "此加盟店无单据", type: "warning"});
              }
            } else {
              this.$message({message: "加盟店获取对账单失败", type: "error"});
            }
          });
        }
      },
      getStore() {
        this.$axios.fetchPost(api.store.store + '/list', {storeClass: 2}).then(data => {
          if (data.code === 200) {
            this.listFormOptions.columns.filter(item => item.prop === "franchiseStoreId")[0].data = data.data;
          } else {
            this.$message({message: "获取加盟店失败", type: "error"});
          }
        })
      },
      selectShowChange(selectRows) {
        let billAmount = 0;
        selectRows.map(item => {
          billAmount = billAmount + parseFloat(item.actualPayAmount);
        });
        this.dataRows = selectRows;
        this.$refs.listOperationForm.formModel.billAmount = billAmount.toFixed(2);
      },
    }
  }
</script>




// WEBPACK FOOTER //
// src/page/settle/franchise/SettlementFranchiseAdd.vue